<template>
  <div :class="size === 'md' ? 'space-y-4' : 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'">
    <!-- Destacados (PRO) -->
    <div :class="size === 'md' ? '' : ''">
      <label
        :class="[
          'flex items-center cursor-pointer',
          size === 'md' ? 'py-2' : '',
        ]"
      >
        <input
          v-model="filters.proOnly"
          type="checkbox"
          :class="checkboxClass"
        />
        <span :class="labelClass">{{ t('colivingSearch.pills.featured') }}</span>
      </label>
    </div>

    <!-- Mascotas -->
    <div :class="size === 'sm' ? 'md:col-span-2 lg:col-span-3' : ''">
      <label :class="fieldLabelClass">{{ t('colivingSearch.advancedFilters.policies.label') }}</label>
      <label class="flex items-center cursor-pointer" :class="size === 'md' ? 'py-2' : ''">
        <input v-model="filters.policies.pets" type="checkbox" :class="checkboxClass" />
        <span :class="labelClass">
          {{ size === 'md' ? t('colivingSearch.advancedFilters.policies.petsAllowed') : t('colivingSearch.advancedFilters.policies.pets') }}
        </span>
      </label>
    </div>

    <!-- Servicios -->
    <div :class="size === 'sm' ? 'md:col-span-2 lg:col-span-3 pt-3 border-t border-gray-200' : ''">
      <label :class="fieldLabelClass">{{ t('colivingSearch.advancedFilters.services.label') }}</label>
      <div :class="size === 'md' ? 'space-y-3' : 'space-y-1'">
        <label class="flex items-center cursor-pointer" :class="size === 'md' ? 'py-2' : ''">
          <input v-model="filters.services.internet" type="checkbox" :class="checkboxClass" />
          <span :class="labelClass">
            {{ size === 'md' ? t('colivingSearch.advancedFilters.services.internetIncluded') : t('colivingSearch.advancedFilters.services.internet') }}
          </span>
        </label>
        <label class="flex items-center cursor-pointer" :class="size === 'md' ? 'py-2' : ''">
          <input v-model="filters.services.cleaning" type="checkbox" :class="checkboxClass" />
          <span :class="labelClass">
            {{ size === 'md' ? t('colivingSearch.advancedFilters.services.cleaningIncluded') : t('colivingSearch.advancedFilters.services.cleaning') }}
          </span>
        </label>
        <label class="flex items-center cursor-pointer" :class="size === 'md' ? 'py-2' : ''">
          <input v-model="filters.services.allIncluded" type="checkbox" :class="checkboxClass" />
          <span :class="labelClass">
            {{ size === 'md' ? t('colivingSearch.advancedFilters.services.allIncludedLong') : t('colivingSearch.advancedFilters.services.allIncluded') }}
          </span>
        </label>
      </div>
    </div>

    <!-- Proveedores -->
    <div
      v-if="availableProviders.length > 0"
      :class="size === 'sm' ? 'md:col-span-2 lg:col-span-3 pt-3 border-t border-gray-200' : 'md:col-span-2 lg:col-span-3 pt-3 border-t border-gray-200'"
    >
      <label :class="fieldLabelClass">
        {{ t('colivingSearch.advancedFilters.providers.label') }}
        <span v-if="filters.providers.length > 0" class="ml-1 text-xs text-indigo-600">({{ filters.providers.length }})</span>
      </label>
      <div :class="size === 'md' ? 'grid grid-cols-2 gap-x-3 gap-y-2' : 'grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-1'">
        <label
          v-for="provider in availableProviders"
          :key="provider.id"
          class="flex items-center cursor-pointer"
          :class="size === 'md' ? 'py-1' : ''"
        >
          <input
            v-model="filters.providers"
            type="checkbox"
            :value="provider.id"
            :class="[checkboxClass, 'flex-shrink-0']"
          />
          <span :class="[labelClass, 'truncate']">{{ provider.name }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const filters = defineModel('filters', { type: Object, required: true });

const props = defineProps({
  availableProviders: { type: Array, default: () => [] },
  size: { type: String, default: 'sm' }, // sm = desktop panel, md = mobile panel
});

const { t } = useI18n();

const fieldLabelClass = computed(() =>
  props.size === 'md'
    ? 'block text-sm font-medium text-gray-700 mb-2'
    : 'block text-xs font-medium text-gray-700 mb-1'
);

const checkboxClass = computed(() =>
  props.size === 'md'
    ? 'h-5 w-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500'
    : 'h-3 w-3 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500'
);

const labelClass = computed(() =>
  props.size === 'md' ? 'ml-3 text-base text-gray-700' : 'ml-2 text-xs text-gray-700'
);
</script>
